import {
  GET_LOGS,
  GET_LOGS_SUCCESS,
  GET_LOGS_FAIL,
} from "./actionTypes";

// Logs

export const getLogs = () => ({
  type: GET_LOGS,
})

export const getLogsSuccess = logs => ({
  type: GET_LOGS_SUCCESS,
  payload: logs,
})

export const getLogsFail = error => ({
  type: GET_LOGS_FAIL,
  payload: error,
})